import {
  ON_START_AKTIVITET_DELK,ON_AKTIVITET_DELK,ON_ERROR_AKTIVITET_DELK,
  ON_START_UPDATE_DATE_AKTIVITET, ON_UPDATE_DATE_AKTIVITETS, ON_ERROR_UPDATE_DATE_AKTIVITET,
  ON_START_GET_AKTIVITETER_USER_NEW,ON_GET_AKTIVITETER_USER_NEW, ON_GET_AKTIVITETER_USER_BUFFER,
    ON_START_NEW_AKTIVITET,
    ON_NEW_AKTIVITET,
    ON_ERROR_NEW_AKTIVITET,
    ON_START_GET_AKTIVITETER_ORGNR,
    ON_GET_AKTIVITETER_ORGNR,
    ON_ERROR_GET_AKTIVITETER_ORGNR,
    ON_START_GET_AKTIVITETER_AVTAL,
    ON_GET_AKTIVITETER_AVTAL,
    ON_ERROR_GET_AKTIVITETER_AVTAL,
    ON_START_GET_AKTIVITETER_ARENDE,
    ON_ERROR_GET_AKTIVITETER_ARENDE,
    ON_GET_AKTIVITETER_ARENDE,
    ON_START_GET_AKTIVITETER_USER,
    ON_GET_AKTIVITETER_USER,
    ON_ERROR_GET_AKTIVITETER_USER,
    ON_START_UPDATE_AKTIVITET,
    ON_START_GET_AKTIVITETET,
    ON_GET_AKTIVITETET,
    ON_UPDATE_AKTIVITET,
    ON_ERROR_GET_AKTIVITETET,    
    ON_OPEN_FILTER_AKTIVITETER,
    ON_ClOSE_FILTER_AKTIVITETER,
    ON_UPDATE_T_AKTIVITET,
    ON_ERROR_UPDATE_T_AKTIVITET,
    ON_START_AKTIVITET_NEWK,
    ON_AKTIVITET_NEWK,
    ON_ERROR_AKTIVITET_NEWK,
    ON_UPDATE_AKTIVITETS,
    ON_ERROR_UPDATE_AKTIVITET,
    SET_AKTIVITETER_FILTER,
    ON_RESET_AKTIVITET_MESSAGE,
    SET_ZERO_AKTIVITET,
    ON_START_GET_AKTIVITETER_USER_TAGS,
    ON_GET_AKTIVETETER_STATS,
    ON_ERROR_GET_AKTIVETETER_STATS,
    ON_START_GET_AKTIVETETER_STATS,
} from "../constants/ActionTypes";
import {isUndefined,isEmpty} from 'lodash'
import { translate } from "../util/intlHelper";

const INIT_STATE = {
    AktivitetList:[],
    AktivitetListAvtaL:[],
    AktivitetListORgnr:[],
    currentAktivitet:{},
    TagsList:[],
    AllTagList:[],
    isLoading:false,
    isBuffering: false,
    AntalAktiv:0,
    Aktivitetmessage:"",
    FilterAktiviterPopup:false,
    AktiviterFilterOption:isUndefined(localStorage.AktiviterFilter)?[]:JSON.parse(localStorage.AktiviterFilter), 
    TolalAktivitet:{},
    AktiviteteStatsTotalt:0,
    AktiviteteStatsForfallna:0
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case SET_ZERO_AKTIVITET:{
        return INIT_STATE;
      }
      case ON_RESET_AKTIVITET_MESSAGE:{
        return { 
          ...state,
          Aktivitetmessage:""
        };
      }
      case SET_AKTIVITETER_FILTER: {
        console.log("SET_AKTIVITETER_FILTER",action.payload)
        localStorage.removeItem("AktiviterFilter");
        localStorage.setItem("AktiviterFilter", JSON.stringify(action.payload));
        return { ...state,
          AktiviterFilterOption: action.payload,
        };
      }
        case ON_START_NEW_AKTIVITET:{
            console.log("ON_START_NEW_AKTIVITET",action)
            return {
              ...state,
              Aktivitetmessage:"",
              currentAktivitet:{},
              isLoading:true
            }
          }
        case ON_NEW_AKTIVITET:{
            console.log("ON_NEW_AKTIVITET",action)
            return {
              ...state,
              Aktivitetmessage:translate("Action.Updated"),
              isLoading:false,
              AntalAktiv:action.payload.Antal,
              AktivitetList:action.payload.Aktiveteter,
              TagsList:action.payload.TagsList,
            }
          }
        case ON_ERROR_NEW_AKTIVITET:{
            console.log("ON_ERROR_NEW_AKTIVITET",action)
            return {
              ...state,
              Aktivitetmessage:translate("Error.Activity.Create"),
              isLoading:false
            }
          }  
        case ON_START_GET_AKTIVITETER_ORGNR:{
            console.log("ON_START_GET_AKTIVITETER_ORGNR",action)
            return {
              ...state,
              AktivitetListORgnr:[],
              TolalAktivitet:{},
              currentAktivitet:{},
              Aktivitetmessage:"",
              isLoading:true
            }
          }
        case ON_GET_AKTIVITETER_ORGNR:{
            console.log("ON_GET_AKTIVITETER_ORGNR",action)
            return {
              ...state,
              Aktivitetmessage:"",
              isLoading:false,
              AntalAktiv:action.payload.Antal,
              AktivitetListORgnr:action.payload.Aktiveteter,
              TolalAktivitet:action.payload.Antal,
            }
          }
        case ON_ERROR_GET_AKTIVITETER_ORGNR:{
            console.log("ON_ERROR_GET_AKTIVITETER_ORGNR",action)
            return {
              ...state,
              Aktivitetmessage:translate("Error.Activity.get"),
              isLoading:false
            }
          }  
        case ON_START_GET_AKTIVITETER_AVTAL:{
            console.log("ON_START_GET_AKTIVITETER_AVTAL",action)
            return {
              ...state,
              AktivitetListAvtaL:[],
              currentAktivitet:{},
              Aktivitetmessage:"",
              isLoading:true
            }
          }
        case ON_GET_AKTIVITETER_AVTAL:{
            console.log("ON_GET_AKTIVITETER_AVTAL",action)
            return {
              ...state,
              Aktivitetmessage:"",
              isLoading:false,
              AntalAktiv:action.payload.Antal,
              AktivitetListAvtaL:action.payload.Aktiveteter,
            }
          }
        case ON_ERROR_GET_AKTIVITETER_AVTAL:{
            console.log("ON_ERROR_GET_AKTIVITETER_AVTAL",action)
            return {
              ...state,
              Aktivitetmessage:translate("Error 1107: Kunde inte hämta Aktiviteter!"),
              isLoading:false
            }
          }  
        case ON_START_GET_AKTIVITETER_ARENDE:{
            console.log("ON_START_GET_AKTIVITETER_ARENDE",action)
            return {
              ...state,
              AktivitetListAvtaL:[],
              currentAktivitet:{},
              Aktivitetmessage:"",
              isLoading:true
            }
          }
        case ON_GET_AKTIVITETER_ARENDE:{
            console.log("ON_GET_AKTIVITETER_ARENDE",action)
            return {
              ...state,
              Aktivitetmessage:"",
              isLoading:false,
              AntalAktiv:action.payload.Antal,
              AktivitetListAvtaL:action.payload.Aktiveteter,
            }
          }
        case ON_ERROR_GET_AKTIVITETER_ARENDE:{
            console.log("ON_ERROR_GET_AKTIVITETER_ARENDE",action)
            return {
              ...state,
              Aktivitetmessage:translate("Error.Cases.Activity.get"),
              isLoading:false
            }
          }  
        //ON_START_GET_AKTIVITETER_USER_NEW,ON_GET_AKTIVITETER_USER_NEW,
        case ON_START_GET_AKTIVITETER_USER_NEW:{
          console.log("ON_START_GET_AKTIVITETER_USER_NEW",action)
          return {
            ...state,
            currentAktivitet:{},
          }
        }
      case ON_GET_AKTIVITETER_USER_NEW:{
          console.log("ON_GET_AKTIVITETER_USER_NEW",action)
          return {
            ...state,
            AntalAktiv:action.payload.Antal,
            AktivitetList:action.payload.Aktiveteter,
            TagsList:action.payload.TagsList,
          }
        }
      case ON_GET_AKTIVITETER_USER_BUFFER:{
          console.log("ON_GET_AKTIVITETER_USER_BUFFER",action)
          return {
            ...state,
            AntalAktiv:action.payload.Antal,
            AktivitetList:[...state.AktivitetList, ...action.payload.Aktiveteter],
            TagsList:action.payload.TagsList,
            isBuffering: false,
          }
        }
        //  
        case ON_START_GET_AKTIVITETER_USER:{
            console.log("ON_START_GET_AKTIVITETER_USER",action)
            return {
              ...state,
            //  AktivitetList:[],
              isBuffering: action.payload.Buffer === 1,
              currentAktivitet:{},
            //  AntalAktiv:0,
              Aktivitetmessage:"",
            //  isLoading:true
            }
          }
        case ON_GET_AKTIVITETER_USER:{
            console.log("ON_GET_AKTIVITETER_USER",action)
            return {
              ...state,
              Aktivitetmessage:"",
              isLoading:false,
              AntalAktiv:action.payload.Antal,
              AktivitetList:action.payload.Aktiveteter,
              TagsList:action.payload.TagsList,
            }
          }
        case ON_START_GET_AKTIVITETER_USER_TAGS:{
            console.log("ON_START_GET_AKTIVITETER_USER_TAGS",action)
            return {
              ...state,
              AllTagList: action.payload.taglist1,
              TagsList: action.payload.taglist2
            }
          }
        case ON_ERROR_GET_AKTIVITETER_USER:{
            console.log("ON_ERROR_GET_AKTIVITETER_USER",action)
            return {
              ...state,
              Aktivitetmessage:"",
              isLoading:false
            }
          }  
        case ON_START_UPDATE_AKTIVITET:{
            console.log("ON_START_UPDATE_AKTIVITET",action)
            return {
              ...state,
              Aktivitetmessage:"",
              isLoading:true,
            }
          }
          case ON_UPDATE_AKTIVITET:{
            console.log("ON_UPDATE_AKTIVITET",action)
            return {
              ...state,
              Aktivitetmessage:action.payload.message,
              AntalAktiv:action.payload.Antal,
              AktivitetList:action.payload.Aktiveteter,
              isLoading:false,
            }
          }

        case ON_UPDATE_AKTIVITETS:{
            console.log("ON_UPDATE_AKTIVITETS",action)
            return {
              ...state,
              AntalAktiv:action.payload.Antal,
              AktivitetList:action.payload.Aktiveteter,
              Aktivitetmessage:action.payload.message,
              isLoading:false,
            }
          }
        case ON_ERROR_UPDATE_AKTIVITET:{
            console.log("ON_ERROR_UPDATE_AKTIVITET",action)
            return {
              ...state,
              Aktivitetmessage:translate("Error.Activity.save"),
              isLoading:false,
            }
          }
          //, , ,      
          case ON_START_UPDATE_DATE_AKTIVITET:{
            console.log("ON_START_UPDATE_DATE_AKTIVITET",action)
            return {
              ...state,
              Aktivitetmessage:"",
              isLoading:true,
            }
          }

        case ON_UPDATE_DATE_AKTIVITETS:{
            console.log("ON_UPDATE_DATE_AKTIVITETS",action)
            return {
              ...state,
              AntalAktiv:action.payload.Antal,
              AktivitetList:action.payload.Aktiveteter,
              Aktivitetmessage:action.payload.message,
              isLoading:false,
            }
          }
        case ON_ERROR_UPDATE_DATE_AKTIVITET:{
            console.log("ON_ERROR_UPDATE_DATE_AKTIVITET",action)
            return {
              ...state,
              Aktivitetmessage:translate("Error.Activity.Date.save"),
              isLoading:false,
            }
          }
//
        case ON_START_GET_AKTIVITETET:{
            console.log("ON_START_GET_AKTIVITETET",action)
            return {
              ...state,
              Aktivitetmessage:"",
              currentAktivitet:{},
              isLoading:true,
            }
          }
        case ON_GET_AKTIVITETET:{
            console.log("ON_GET_AKTIVITETET",action)
            return {
              ...state,
              Aktivitetmessage:"",
              currentAktivitet:action.payload.currentAktivitet,
              isLoading:false
            }
          }  
        case ON_ERROR_GET_AKTIVITETET:{
            console.log("ON_ERROR_GET_AKTIVITETET",action)
            return {
              ...state,
              Aktivitetmessage:translate("Error.ActivityK.get"),
              isLoading:false,
            }
          }
        case ON_OPEN_FILTER_AKTIVITETER:{
            console.log("ON_OPEN_FILTER_AKTIVITETER",action)
            return {
              ...state,
              FilterAktiviterPopup:true,
              AktiviterFilterOption:isUndefined(localStorage.AktiviterFilter)?[]:JSON.parse(localStorage.AktiviterFilter)
            }
          }
        case ON_ClOSE_FILTER_AKTIVITETER:{
            console.log("ON_ClOSE_FILTER_AKTIVITETER",action)
            return {
              ...state,
              FilterAktiviterPopup:false
            }
          }
          case ON_UPDATE_T_AKTIVITET:{
            console.log("ON_UPDATE_T_AKTIVITET",action)
            return {
              ...state,
              isLoading:false,
              Aktivitetmessage:action.payload.message,
              currentAktivitet:action.payload.currentAktivitet,
            }
          }
          case ON_ERROR_UPDATE_T_AKTIVITET:{
            console.log("ON_ERROR_UPDATE_T_AKTIVITET",action)
            return {
              ...state,
              isLoading:false,
              Aktivitetmessage:translate("Error.Activity.save"),
            }
          }          
          case ON_START_AKTIVITET_NEWK:{
            console.log("ON_START_AKTIVITET_NEWK",action)
            return {
              ...state,
              isLoading:false,
            }
          }
          case ON_AKTIVITET_NEWK:{
            console.log("ON_AKTIVITET_NEWK",action)
            return {
              ...state,
              isLoading:false,
              Aktivitetmessage:action.payload.message,
              currentAktivitet:action.payload.currentAktivitet,
            }
          }       
          case ON_ERROR_AKTIVITET_NEWK:{
            console.log("ON_ERROR_AKTIVITET_NEWK",action)
            return {
              ...state,
              isLoading:false,
              Aktivitetmessage:translate("Error.ActivityK.message"),
            }
          }  
          //ON_START_AKTIVITET_DELK,ON_AKTIVITET_DELK,ON_ERROR_AKTIVITET_DELK,
          case ON_START_AKTIVITET_DELK:{
            console.log("ON_START_AKTIVITET_DELK",action)
            return {
              ...state,
              isLoading:false,
            }
          }
          case ON_AKTIVITET_DELK:{
            console.log("ON_AKTIVITET_DELK",action)
            return {
              ...state,
              isLoading:false,
              Aktivitetmessage:action.payload.message,
              currentAktivitet:action.payload.currentAktivitet,
            }
          }       
          case ON_ERROR_AKTIVITET_DELK:{
            console.log("ON_ERROR_AKTIVITET_DELK",action)
            return {
              ...state,
              isLoading:false,
              Aktivitetmessage:translate("Error.ActivityK.message.delete"),
            }
          } 
          case ON_GET_AKTIVETETER_STATS: {
            return {
              ...state,
              AktiviteteStatsTotalt:action.payload.AktiviteteStatsTotalt,
              AktiviteteStatsForfallna:action.payload.AktiviteteStatsForfallna,
            }
          }
          case ON_ERROR_GET_AKTIVETETER_STATS: {
            return {
              ...state,
              AktiviteteStatsTotalt:0,
              AktiviteteStatsForfallna:0
            }
          }
          case ON_START_GET_AKTIVETETER_STATS: {
            return {
              ...state,
              AktiviteteStatsTotalt:0,
              AktiviteteStatsForfallna:0
            }
          }
          //       
        default:
            return state;  
    } 
}

